import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

const inlineCommentKey = new PluginKey('inlineComment');

export const InlineComment = Extension.create({
    name: 'inlineComment',

    addProseMirrorPlugins() {
        
        return [
            new Plugin({
                key: inlineCommentKey,
                
                state: {
                    init(_, { doc }) {
                        return findInlineComments(doc);
                    },
                    apply(tr, old) {
                        if (tr.docChanged) {
                            return findInlineComments(tr.doc);
                        }
                        return old.map(tr.mapping, tr.doc);
                    }
                },
                
                props: {
                    decorations(state) {
                        return this.getState(state);
                    },
                    
                    handleTextInput(view, from, to, text) {
                        // Auto-close brackets when user types [[
                        if (text === '[' && from > 0) {
                            const beforeChar = view.state.doc.textBetween(from - 1, from, null, '\uffff');
                            if (beforeChar === '[') {
                                const tr = view.state.tr;
                                tr.insertText('[[]]', from - 1, to);
                                // Set cursor position between the brackets
                                tr.setSelection(view.state.selection.constructor.near(tr.doc.resolve(from + 1)));
                                view.dispatch(tr);
                                return true;
                            }
                        }
                        return false;
                    }
                }
            })
        ];
    }
});

// Find all [[comment]] patterns in the document
function findInlineComments(doc) {
    const decorations = [];
    // Match [[...]] where ... can be any characters except the sequence ]]
    const commentRegex = /\[\[(?:[^\]]|\](?!\]))*\]\]/g;
    
    doc.descendants((node, pos) => {
        if (!node.isText) return;
        
        const text = node.text;
        let match;
        
        while ((match = commentRegex.exec(text)) !== null) {
            const start = pos + match.index;
            const end = start + match[0].length;
            
            // Apply decoration to mark this as a comment
            decorations.push(
                Decoration.inline(start, end, {
                    class: 'spec-inline-comment'
                })
            );
        }
    });
    
    return DecorationSet.create(doc, decorations);
}

// Helper function to strip comments from text for word counting
export function stripInlineComments(text) {
    // Use the same regex as findInlineComments for consistency
    return text.replace(/\[\[(?:[^\]]|\](?!\]))*\]\]/g, '');
}